const AVATAR_COLORS = ["#0F6CBD", "#8764B8", "#038387", "#C239B3", "#CA5010", "#498205", "#986F0B", "#005B70"];

export const avatarColor = (email = "") => {
  let h = 0;
  for (let i = 0; i < email.length; i++) h = (h * 31 + email.charCodeAt(i)) >>> 0;
  return AVATAR_COLORS[h % AVATAR_COLORS.length];
};

export const SenderAvatar = ({ email = "", name = "", size = 34 }) => (
  <span
    className="rounded-full flex items-center justify-center text-white font-semibold shrink-0"
    style={{ width: size, height: size, backgroundColor: avatarColor(email), fontSize: size * 0.42 }}
    aria-hidden="true"
  >
    {(name || email || "?").trim()[0]?.toUpperCase()}
  </span>
);
